import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Flex, Image, Text } from '@thirstycamel/ui'

const Tile = styled.div`
  background: #acca57;
  color: #fff;
  border-radius: 16px;
  padding: 18px 20px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
`

const MobileOverrides = styled.div`
  @media (max-width: 48em) {
    display: flex;
    flex-direction: column;
    gap: 10px;
    min-height: 100px;
    min-width: 0;

    .kpiTitle {
      font-size: clamp(16px, 3.6vw, 20px);
      line-height: 1.2;
      min-height: calc(1.2em * 2);
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .kpiRow {
      min-width: 0;
    }

    .kpiValue {
      font-size: clamp(22px, 5vw, 30px);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      min-width: 0;
    }
  }
`

type Props = {
  label: string
  value: string
}

const iconMap = {
  'Total Sign Ups': '/static/images/list.png',
  'Completed Sign Ups': '/static/images/tick.png',
  'Unique Customers': '/static/images/user.png',
  'Tag Rate': '/static/images/lock.png',
  'Hump Club Revenue': '/static/images/money.png',
  'Hump Club Transactions': '/static/images/till.png',
  'My Offers Claimed': '/static/images/claim.png',
  'Average Basket Value': '/static/images/shopping-basket.png',
  'Total Offers Redeemed': '/static/images/claim.png',
  'Total Reimbursement Amount': '/static/images/money.png',
}

export const useWindowSize = () => {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768)
    }

    checkMobile()
    window.addEventListener('resize', checkMobile)
    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  return isMobile
}

const ReportingKpiTile = ({ label, value }: Props) => {
  const isMobile = useWindowSize()

  return (
    <Tile>
      <MobileOverrides>
        <Text className="kpiTitle" fontSize="xl" fontWeight="extrabold" color="white" mb={2}>
          {label}
        </Text>
        <Flex className="kpiRow" direction="row" justifyContent="space-between" alignItems="center">
          {!isMobile ? (
            <Image
              src={iconMap[label]}
              alt={label}
              width={12}
              height={12}
              style={{ filter: 'invert(1)' }}
            />
          ) : (
            <Image
              src={iconMap[label]}
              alt={label}
              width={8}
              height={8}
              mr={2}
              style={{ filter: 'invert(1)' }}
            />
          )}

          <Text
            className="kpiValue"
            fontSize="3xl"
            fontWeight="extrabold"
            color="#cd1f3d"
            textAlign="right"
          >
            {value}
          </Text>
        </Flex>
      </MobileOverrides>
    </Tile>
  )
}

export default ReportingKpiTile
